/**
 * @fileoverview パスワード変更失敗画面のコンポーネント
 *
 * このファイルでは、パスワード変更処理中にエラーが発生した場合に
 * 表示されるエラーメッセージ画面を定義しています。
 */

/**
 * パスワード変更失敗画面コンポーネント
 *
 * パスワードの変更処理中に発生したエラーの詳細をユーザーに表示し、
 * 再試行やヘルプへのリンク、代替アクションなどを提供します。
 * URLクエリパラメーターからエラー情報を取得して表示する機能も含みます。
 *
 * @returns {JSX.Element} パスワード変更失敗メッセージ画面
 */
import { Stack, Text } from "@mantine/core";

import { useNavigate } from "@/router";
import { Card } from "@/components/card";
import { Button } from "@/components/button";

export default function ChagnePasswordPage() {
  const navigate = useNavigate();

  return (
    <Card title="パスワード変更">
      <Stack className="gap-10">
        <Text>パスワードの変更に失敗しました。</Text>
        <div className="flex justify-end">
          <Button text="マイページへ戻る" onClick={() => navigate("/user")} />
        </div>
      </Stack>
    </Card>
  );
}
